import { CRM_CONFIG } from '@/config/constants';

interface RequestOptions {
  method: 'GET' | 'POST' | 'PUT' | 'DELETE';
  body?: unknown;
  useWriteUrl?: boolean;
}

export class CrmClient {
  private static instance: CrmClient;

  private constructor() {}

  static getInstance(): CrmClient {
    if (!CrmClient.instance) {
      CrmClient.instance = new CrmClient();
    }
    return CrmClient.instance;
  }

  async request<T>(endpoint: string, options: RequestOptions): Promise<T> {
    const baseUrl = options.useWriteUrl
      ? CRM_CONFIG.BASE_URL_WRITE
      : CRM_CONFIG.BASE_URL_READ;

    const url = `${baseUrl}${endpoint}`;

    const headers: Record<string, string> = {
      Token: CRM_CONFIG.TOKEN
    };

    if (options.body) {
      headers['Content-Type'] = 'application/json';
    }

    console.log(`[CRM] ${options.method} ${url}`);
    if (options.body) {
      console.log('[CRM] Request body:', JSON.stringify(options.body, null, 2));
    }

    try {
      const response = await fetch(url, {
        method: options.method,
        headers,
        body: options.body ? JSON.stringify(options.body) : undefined
      });

      const text = await response.text();
      console.log(`[CRM] Response status: ${response.status} ${response.statusText}`);
      console.log('[CRM] Response body:', text || '(empty)');

      if (!response.ok) {
        throw new Error(`CRM API Error: ${response.status} ${response.statusText} - ${text}`);
      }

      if (!text) {
        return {} as T;
      }

      return JSON.parse(text) as T;
    } catch (error) {
      console.error('[CRM] Request failed:', error);
      throw error;
    }
  }

  async get<T>(endpoint: string): Promise<T> {
    return this.request<T>(endpoint, { method: 'GET' });
  }

  async post<T>(endpoint: string, body: unknown, useWriteUrl = false): Promise<T> {
    return this.request<T>(endpoint, {
      method: 'POST',
      body,
      useWriteUrl
    });
  }
}

export const crmClient = CrmClient.getInstance();
